export default "../fonts/ab-manager.svg";